// src/components/DroneControl.js
import React, { useState } from "react";

let bleDevice = null;
let bleCharacteristic = null;
const SERVICE_UUID = "12345678-1234-1234-1234-1234567890ab";
const CHARACTERISTIC_UUID = "87654321-4321-4321-4321-abcdefabcdef";

const DroneControl = () => {
  const [isEngaged, setIsEngaged] = useState(false);

  // Connect to ESP32
const connectToESP32 = async () => {
  try {
    if (bleCharacteristic) return; // Already connected
    bleDevice = await navigator.bluetooth.requestDevice({
      filters: [{ name: "ESP32_BLUETOOTH_LED" }],
      optionalServices: [SERVICE_UUID],
    });

    const server = await bleDevice.gatt.connect();
    const service = await server.getPrimaryService(SERVICE_UUID);
    bleCharacteristic = await service.getCharacteristic(CHARACTERISTIC_UUID);

    alert("✅ Connected to ESP32!");
  } catch (err) {
    console.error(err);
    alert("❌ Bluetooth connection failed");
  }
};


  // Send command to ESP32
  const sendBLECommand = async (command) => {
    if (!bleCharacteristic) {
      alert("Bluetooth not connected");
      return;
    }
    const encoder = new TextEncoder();
    await bleCharacteristic.writeValue(encoder.encode(command));
    console.log("Sent:", command);
  };

  // Toggle Engage/Disengage
  const handleToggle = async () => {
    try {
      if (!bleCharacteristic) await connectToESP32();
      if (!isEngaged) {
        await sendBLECommand("H"); // Engage
      } else {
        await sendBLECommand("L"); // Disengage
      }
      setIsEngaged(!isEngaged);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div style={{ padding: "20px", textAlign: "center", fontColor: "#fff" }}>
      <h2 style={{color: "white"}}>Drone Control Panel</h2>
      <p>Use the button below to engage or disengage the drone.</p>
      <button
        onClick={handleToggle}
        style={{
          padding: "15px 25px",
          fontSize: "18px",
          borderRadius: "8px",
          border: "none",
          backgroundColor: isEngaged ? "#dc3545" : "#28a745",
          color: "white",
          cursor: "pointer",
        }}
      >
        {isEngaged ? "Disengage Drone" : "Engage Drone"}
      </button>
    </div>
  );
};

export default DroneControl;
